import { render, staticRenderFns } from "./MedicalCases.vue?vue&type=template&id=546b6b56&"
import script from "./MedicalCases.vue?vue&type=script&lang=js&"
export * from "./MedicalCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports